import { render, staticRenderFns } from "./ProductStockFlow.vue?vue&type=template&id=9c0ea988&"
import script from "./ProductStockFlow.vue?vue&type=script&lang=js&"
export * from "./ProductStockFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports